export class StrongoShipmentParcelHistory {
    public id: number;
    public strongo_shipment_parcel_id: number;
    public last_status_date: Date | null;
    public status: string;
    public hub_location: string;
    public code: string;
    public tooltip: string;
    public description: string;

    constructor(data: StrongoShipmentParcelHistoryData | void) {
        if (data === undefined) {
            this.id = 0;
            this.strongo_shipment_parcel_id = 0;
            this.last_status_date = null;
            this.status = "";
            this.hub_location = "";
            this.code = "";
            this.tooltip = "";
            this.description = "";
        } else {
            this.id = data.id;
            this.strongo_shipment_parcel_id = data.strongo_shipment_parcel_id;
            this.last_status_date = null;
            if (data.last_status_date !== null) {
                this.last_status_date = new Date(data.last_status_date);
            }
            this.status = data.status;
            this.hub_location = data.hub_location;
            this.code = data.code;
            this.tooltip = data.tooltip;
            this.description = data.description;
        }
    }
}

export type StrongoShipmentParcelHistoryData = {
    id: number;
    strongo_shipment_parcel_id: number;
    last_status_date: Date | null;
    status: string;
    hub_location: string;
    code: string;
    tooltip: string;
    description: string;
}